import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { VinsBuquesService } from '../../servicios/vins-buques.service';
import { Column, GridOption, Formatters, AngularGridInstance, DelimiterType, FileType, ExtensionName, Formatter } from 'angular-slickgrid';
import { DateAdapter } from '@angular/material/core';
import { vinsVisita, visitaBuqueDTO } from 'src/app/entidades/entidades.component';
import * as XLSX from 'xlsx';
import { AveriasService } from 'src/app/servicios/averias.service';
import { SnackBarComponent } from '../../snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PerfilesUsuarioService } from 'src/app/servicios/perfiles-usuario.service';
import { NbDialogService } from '@nebular/theme';
import { VinsBuquesDeleteOrDismissComponent } from '../vins-buques-delete-or-dismiss/vins-buques-delete-or-dismiss.component';
import { AnalyticsService } from '../../servicios/analytics.service';
import { ChangeTabsService } from 'src/app/servicios/change-tabs.service';
//import {SharedModule} from '../../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
import { NbCheckboxModule } from '@nebular/theme';
import { VinsBuquesPopupValidExpoComponent } from '../vins-buques-popup-valid-expo/vins-buques-popup-valid-expo.component';
import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';


@Component({
    selector: 'app-vins-buques-modif',
    templateUrl: './vins-buques-modif.component.html',
    styleUrls: ['./vins-buques-modif.component.css'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, 
      NbCheckboxModule, NbCardModule, NbIconModule, DropdownModule,
       MatCardModule, MatFormFieldModule, MatInputModule,
        AngularSlickgridModule, NbTabsetModule, 
        MatDatepickerModule, MatNativeDateModule, 
        NbSelectModule, NbTreeGridModule, SpinnerComponent, 
        MultiSelectModule,
        AgGridAngular],
})
export class VinsBuquesModifComponent implements OnInit {
  file
  fileName:string=""
  cargoArchivo:boolean = false;
  idCliente: number;
  visitaSelected;
  habilitarGuardar:boolean = false;
  deshabilitarProceso: boolean = true;
  deshabilitarOperador: boolean = true;
  ocultarFechas:boolean = true;
  visitas: SelectItem[];
  buquesVisita;
  buquesVisitaSeleccionado: visitaBuqueDTO = {
    idVisita: 0,
    idBuque:0,
    proceso: "",
    nombreBuque:"", 
    codVisitaExterno:"", 
    fechaArribo: null, 
    fechaPartida: null,
    etd: null,
    eta: null,
    ata: null,
    atd: null,
    idProceso : 0,
    codVerificacion: 0
  };
  buqueSeleccionado;
  procesoSelected;
  procesos: SelectItem[];
  procesoModSelected=0;
  dataVinsModif: any = [];
  angularGridVinsModif: AngularGridInstance;
  columnDefinitionsVinsModif: ColDef[];//Column[];
  gridOptionsVinsModif: GridOption;
  showGridModif = false;
  vinsDeLaVisita: vinsVisita[] = [];
  fechaModETA = null;
  fechaModATA = null;
  fechaModETD = null;
  fechaModATD = null;
  diaHoy = new Date();
  eliminarSeleccionado: boolean = false;
  showSpinnerGuardar:boolean = false;
  showSpinnerUpload:boolean = false;
  durationInSeconds = 3;
  tabActivo;
  operadores = [];
  operadorSelected;
  diaTomorrow = new Date(new Date().setDate(new Date().getDate() + 2));
 @ViewChild('grilla1') grilla1!: AgGridAngular;


  constructor(private svcVinsBuq: VinsBuquesService, private _snackBar: MatSnackBar,
    private svcAverias: AveriasService, private adapter: DateAdapter<any>,
    public usersRol: PerfilesUsuarioService, private dialogService: NbDialogService,
    private changeVinsBuques: ChangeTabsService, private svcAnalytics: AnalyticsService ) { }

  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem('idCliente'))
    this.changeVinsBuques.tabVinsBuques.subscribe(data => {
      this.tabActivo = data;
      this.tabActivo == "Modificacion" ? this.getBuquesVisita() : null;
    })
    this.adapter.setLocale('es-MX');
    this.getBuquesVisita();
    this.svcAnalytics.setAnalyticsPageView();
  }
  angularGridReadyVinsModif(angularGrid: AngularGridInstance) {
    this.angularGridVinsModif = angularGrid;
    this.angularGridVinsModif.resizerService.pauseResizer(false)
  }
  getBuquesVisita(){
    this.svcVinsBuq.getBuquesVisitaAbiertas(this.idCliente).subscribe(
      data => {
        this.buquesVisita = data;
        this.visitas = this.insertarBuquesVisita(this.buquesVisita);
      })
  }
  insertarBuquesVisita(arg) {
    let buques: Array<any> = [];
    arg.forEach(element => {
      buques.push({
        label: element.nombreBuque + " - " + element.codVisitaExterno,
        value: element.codVisitaExterno + ";" + element.idBuque
      });
    })
    return buques;
  }
  
  insertarProceso(arg) {
    let procesos: Array<any> = [];
    arg.forEach(element => {
      procesos.push({
        label: element.nameProc,
        value: element.idProc,
      });
    })
    return procesos;
  }
  ingresarDatosGrillaModif(){
    this.columnDefinitionsVinsModif = [
      //   headerName: 'VIN', field: 'VIN', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
  
      {// id: 'VIN', 
        headerName: 'VIN', 
        field: 'VIN', sortable: true, 
        filter: true, floatingFilter: true,
        minWidth: 120, width: 120, },
      { //id: 'OrigenDestino', 
        headerName: 'Origen/Destino', 
        field: 'OrigenDestino', sortable: true, 
        filter: true, floatingFilter: true, 
        minWidth: 120, width: 120, },
      { //id: 'nfactura', 
        headerName: 'Factura', field: 'nfactura', 
        sortable: true, filter: true, floatingFilter: true, minWidth: 60, width: 60, },
      { //id: 'bl', 
        headerName: 'BL', field: 'bl', sortable: true, 
        filter: true, floatingFilter: true, minWidth: 60, width: 60, },
    ];
    this.gridOptionsVinsModif = {
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
    this.showGridModif = true;
  }
  changeVisita(buqueSelected) {
    
    this.buqueSeleccionado = null;
    this.operadorSelected = null;
    this.procesoSelected = null;
    this.deshabilitarProceso = true;
    this.habilitarGuardar = false;
    this.ocultarFechas = true;
    let idBuque = buqueSelected.split(';')[1];
    let codigoDeVisita = buqueSelected.split(';')[0];

    let buq = this.buquesVisita.find(n => n.idBuque == idBuque && n.codVisitaExterno == codigoDeVisita);
    this.buqueSeleccionado = buq;

    this.operadores = [];
    
    this.buqueSeleccionado.operadores.forEach(op => {
      this.operadores.push({value: op.id, label:op.descripcion})
    });
    this.deshabilitarOperador = false;
  }
  
  changeOperador(opSelected){
    this.procesoSelected = null;
    this.habilitarGuardar = false;

    let _proc = [];
    _proc = this.buqueSeleccionado.datosVisita.filter( element => element.idOperador == opSelected);

    this.procesos = this.insertarProcesos(_proc)
    this.deshabilitarProceso = false;
  }

  changeProceso(proceso){
    let visita;
    this.buquesVisitaSeleccionado= this.buqueSeleccionado.datosVisita.find(n=> n.idProceso == proceso)
    this.ocultarFechas = false;
    this.habilitarGuardar = true;
    this.procesoModSelected = this.buquesVisitaSeleccionado.idProceso;
    this.fechaModATA = this.buquesVisitaSeleccionado.ata;
    this.fechaModETA = this.buquesVisitaSeleccionado.eta;
    this.fechaModETD = this.buquesVisitaSeleccionado.etd;
    this.fechaModATD = this.buquesVisitaSeleccionado.atd;

    this.showGridModif = false;
    this.dataVinsModif = [];
  }
  cargarGrillaMod(){
    this.showGridModif = false;
    this.cargoArchivo= false;

    let mockDataset: any= [];
    this.dataVinsModif= [];
    this.vinsDeLaVisita = [];
    var columns=[];
    var keys = Object.keys(this.file[0]);
    keys.forEach( function(key) {
      columns.push(key);
    })

    if (columns.length < 2){
      alert("El archivo debe contener como minimo 2 columnas")
      this.showSpinnerUpload = false;
      return
    }

    if (columns.length > 4){
      alert("El archivo debe contener como maximo 4 columnas")
      this.showSpinnerUpload = false;
      return
    }

    for (let i = 0; i < this.file.length; i++) {
      mockDataset.push({
        id: i,
        VIN: this.file[i][columns[0]],
        OrigenDestino: this.file[i][columns[1]],
        // nfactura: this.file[i][columns[2]],
        // bl: this.file[i][columns[3]]
        // VIN: this.file[i]["vin"],
        // OrigenDestino: this.file[i]["origen"],
        nfactura: this.file[i]["factura"],
        bl: this.file[i]["bl"]
      });
      this.vinsDeLaVisita.push({
        vin: this.file[i][columns[0]],
        destinoOrigen: this.file[i][columns[1]],
        numeroFactura: this.file[i]["factura"],
        bl: this.file[i]["bl"]
      })
    }

    this.ValidarVinsVisitasAbiertas(this.vinsDeLaVisita.map(({ vin }) => vin));

    if (this.procesoModSelected == 2){
      this.validarInspeccionesExistentes(this.vinsDeLaVisita.map(({ vin }) => vin));
    }
    else {
      this.showSpinnerUpload = false;
    }

    this.showGridModif = true;
    this.cargoArchivo= true;
    this.dataVinsModif = mockDataset;
  }

  
    openVinsIspeccDialog(data, descipciontitulo, filename) {
      const dialogRef = this.dialogService.open(VinsBuquesPopupValidExpoComponent, {
        context: { dialogData : data , title: descipciontitulo, namefilexls: filename },
      });
    }
  

    ValidarVinsVisitasAbiertas(vins: string[]){  
      let codigovisitaExt: string = this.visitaSelected.split(';')[0];
        this.svcAverias.vinsExistentesenVisita(this.idCliente,vins, codigovisitaExt).subscribe(
          data => {
            if (data["status"] == 200) {
              if (data["body"].length > 0){
                this.openVinsIspeccDialog(data["body"],"Los siguientes VINS ya tienen asociadas otras visitas activas",'VINS CON VISITAS ABERTAS');
                this.openSnackBar('Error al dar de alta listado de unidades, existen unidades asociadas a otras visitas activas: … ');
                 this.habilitarGuardar = false;
              }
              else
                this.openSnackBar('Los datos se han validado correctamente');
            
            } else {
              this.openSnackBar('Ha ocurrido un error al validar los datos');
            }
            this.showSpinnerUpload = false;
          }, error=>{
            this.openSnackBar('Ha ocurrido un error al validar los datos');
            this.showSpinnerUpload= false;
          }
        )
      }



  validarInspeccionesExistentes(vins: string[]){  
    this.svcAverias.vinsConInspeccionPrevia(this.idCliente,vins).subscribe(
      data => {
        if (data["status"] == 200) {
          if (data["body"].length > 0){
            alert("Algunos chasis no tienen Inspecciones previas");
          }
          this.openSnackBar('Los datos se han validado correctamente');
        } else {
          this.openSnackBar('Ha ocurrido un error al validar los datos');
        }
        this.showSpinnerUpload = false;
      }, error=>{
        this.openSnackBar('Ha ocurrido un error al validar los datos');
        this.showSpinnerUpload= false;
      }
    )
  }
  addfile(event) {
    this.showSpinnerUpload = true;
    var validExts = new Array(".xlsx", ".xls");
    var fileExt = event.srcElement.files[0].name;
    fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
    if (validExts.indexOf(fileExt) < 0) {
      alert("Archivo seleccionado inválido, debe ser de extensión tipo" +  validExts.toString());
      return;
    }

    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(event.target);
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      /* create workbook */
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.file = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
      this.fileName = target.files[0].name;
      this.cargarGrillaMod();
      this.ingresarDatosGrillaModif();

      this.habilitarBotonGuardar();
    };
  }
  habilitarBotonGuardar(){
    if (this.cargoArchivo)
      this.habilitarGuardar = true;
    else
      this.habilitarGuardar = false;
  }
  changeFechaModETA(ev){
    // if (ev != null || ev != undefined){
    //   if (ev < this.diaHoy) {
    //     this.fechaModETA = this.diaHoy
    //     alert("La fecha no puede ser menor al día de la fecha")        
    //   }
    // }
  }
  changeFechaModATA(ev){
    // if (ev != null || ev != undefined){
    //   if (ev < this.diaHoy) {
    //     this.fechaModATA = this.diaHoy
    //     alert("La fecha no puede ser menor al día de la fecha")        
    //   }
    // }
  }
  changeFechaModETD(ev){
    // if (ev != null || ev != undefined){
    //   if (ev < this.diaHoy) {
    //     this.fechaModETD = this.diaHoy
    //     alert("La fecha no puede ser menor al día de la fecha")
    //   }
    // }
  }
  changeFechaModATD(ev){
    // if (ev != null || ev != undefined){
    //   if (ev < this.diaHoy) {
    //     this.fechaModATD = this.diaHoy
    //     alert("La fecha no puede ser menor al día de la fecha")
    //   }
    // }
  }
  guardarModificacion(){
    this.showSpinnerGuardar = true;
    if (this.eliminarSeleccionado){
      this.svcAverias.deleteVisita(this.buquesVisitaSeleccionado.idVisita).subscribe(
        data => {
          if (data["status"] == 200) {
            this.openSnackBar('La Visita se elimino correctamente');
            //gtag Baja
            this.svcAnalytics.setAnalyticsBajaButton();
            this.resetearValores();
          } else {
            this.openSnackBar('Ha ocurrido un error al eliminar las visita');
          }
          this.showSpinnerGuardar = false;
        }, error=>{
          this.openSnackBar('Ha ocurrido un error al eliminar las visita');
          this.showSpinnerGuardar= false;
        }
      )
    }
    else {
      let _dtoVisitaSave = {
        idVisita: this.buquesVisitaSeleccionado.idVisita,
        etd: this.fechaModETD,
        eta: this.fechaModETA,
        atd: this.fechaModATD,
        ata: this.fechaModATA,
        detalleVisita: this.vinsDeLaVisita
      }
      this.svcVinsBuq.modificarVisitaDetalle(_dtoVisitaSave).subscribe( data =>{
        if (data["status"] == 200){
          if (data["body"].length > 0 && this.fileName != ""){
            this.openConfirmDLTDialog(data["body"])
            this.showSpinnerGuardar = false;
          }else{
            this.openSnackBar('La modificación ha sido exitosa.');
            this.showSpinnerGuardar = false;
             //gtag modificacion
            this.svcAnalytics.setAnalyticsModificacionButton(); 
            this.resetearValores();
          }
        }else{
          this.openSnackBar('Ha ocurrido un error al modificar la visita.');
          this.showSpinnerGuardar = false;
        }
      })
    }
  }
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }
  resetearValores(){
    this.buquesVisitaSeleccionado = {
      idVisita: 0,
      idBuque:0,
      proceso: "",
      nombreBuque:"", 
      codVisitaExterno:"", 
      fechaArribo: null, 
      fechaPartida: null,
      etd: null,
      eta: null,
      ata: null,
      atd: null,
      idProceso : 0,
      codVerificacion: 0
    };
    this.visitaSelected = null;
    this.eliminarSeleccionado = false;
    this.fechaModATA = null;
    this.fechaModETA = null;
    this.fechaModETD = null;
    this.fechaModATD = null;
    this.ocultarFechas = true;
    this.habilitarGuardar = false;
    this.procesoModSelected = 0;
    this.procesoSelected = null;
    this.operadorSelected = null;
    this.showGridModif = false;
    this.dataVinsModif = [];
    this.getBuquesVisita();
  }

  openConfirmDLTDialog(data) {
    const dialogRef = this.dialogService
      .open(VinsBuquesDeleteOrDismissComponent, { context: { dialogData : data, visita: this.buquesVisitaSeleccionado.idVisita }})
      .onClose.subscribe(res => { 
        if(res.closedBy == 1){
          this.resetearValores()
        }
      });
  }
  insertarProcesos(arg) {
    let procesos: Array<any> = [];
    arg.forEach(element => {
      procesos.push({
        label: element.proceso,
        value: element.idProceso,
      });
    })
    return procesos;
  }

    onGridReady(params: GridReadyEvent): void {
      this.grilla1.api.sizeColumnsToFit();
    
    }


}
